import React, { useState, useEffect } from "react";
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle,
} from "@mui/material";
import { MultiSelect } from "react-multi-select-component";  // ✅ correct
import { collection, getDocs, addDoc } from "firebase/firestore";
import { db, loginAdmin } from "../../Firebase";
import toast from "react-hot-toast";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// ✅ base_url removed — not used in this file
import NotificationsTable from "./NotificationsTable";

const Notifications = () => {
  const [users, setUsers] = useState([]);
  const [open, setOpen] = useState(false);
  const [notificationText, setNotificationText] = useState("");
  const [notificationTitle, setNotificationTitle] = useState("");
  const [notificationsList, setNotificationsList] = useState([]);
  const [selectFromMS, setselectFromMS] = useState([]);

  const fetchUserNotification = async () => {
    try {
      await loginAdmin();
      const notificationsSnapshot = await getDocs(collection(db, "notifications"));
      const list = notificationsSnapshot.docs.map((doc) => {
        const data = doc.data();
        const createdAt = data.sentAt?.toDate
          ? data.sentAt.toDate()
          : data.createdAt?.toDate
          ? data.createdAt.toDate()
          : new Date();
        return {
          id: doc.id,
          createdAt: createdAt.toLocaleString(),
          username: "Admin",
          notificationType: data.title || data.notificationType || "",
          notificationText: data.body || data.notificationText || "",
        };
      });
      list.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      setNotificationsList(list);
    } catch (error) {
      console.error("Error fetching notifications:", error);
      toast.error("Failed to load notifications");
    }
  };

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        await loginAdmin();
        const userSnapshot = await getDocs(collection(db, "users"));
        const usersList = userSnapshot.docs.map((doc) => ({
          id: doc.id,
          uid: doc.data().uid || doc.id,
          ...doc.data(),
        }));
        setUsers(
          usersList
            ?.filter((u) => !!u.name?.trim())
            ?.map((u) => ({ value: u.id || u.uid, label: u.name, email: u.email || "" })) || []
        );
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };
    fetchUserNotification();
    fetchUsers();
  }, []);

  const handleNotificationTitle = (e) => {
    const v = e.target.value;
    setNotificationTitle(v.charAt(0).toUpperCase() + v.slice(1));
  };

  const handleNotificationTextChange = (e) => {
    const v = e.target.value;
    setNotificationText(v.charAt(0).toUpperCase() + v.slice(1));
  };

  const handleNotificationSubmit = async (e) => {
    e.preventDefault();
    const userIdsTemp = selectFromMS.map((item) => item.value);
    if (!notificationTitle || !notificationText) {
      toast.error("Title or text is empty");
      setOpen(false);
      return;
    }
    try {
      await loginAdmin();
      const newNotification = {
        title: notificationTitle,
        body: notificationText,
        sentToUserIds: userIdsTemp,
        type: "admin_broadcast",
        sentAt: new Date(),
      };
      const docRef = await addDoc(collection(db, "notifications"), newNotification);
      for (const userId of userIdsTemp) {
        await addDoc(collection(db, "users", userId, "notifications"), {
          id: docRef.id,
          title: notificationTitle,
          body: notificationText,
          createdAt: new Date(),
          read: false,
          type: "admin_broadcast",
        });
      }
      toast.success("Notification sent successfully");
      setOpen(false);
      setNotificationTitle("");
      setNotificationText("");
      setselectFromMS([]);
      fetchUserNotification();
    } catch (error) {
      setOpen(false);
      toast.error("Error sending notification");
      console.error(error);
    }
  };

  return (
    <div style={{
      flex: 1,
      minHeight: "100vh",
      backgroundColor: "#374151",
      color: "white",
      padding: "24px 16px",
      boxSizing: "border-box",
      overflowX: "hidden",
    }}>
      <ToastContainer />

      {/* Confirm Dialog */}
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Confirmation</DialogTitle>
        <DialogContent>Do you really want to send a notification?</DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} color="secondary">No</Button>
          <Button onClick={handleNotificationSubmit} color="error">Yes</Button>
        </DialogActions>
      </Dialog>

      {/* ✅ HEADER */}
      <h1 style={{
        margin: "0 0 24px 0",
        fontSize: "clamp(1.5rem, 4vw, 2.5rem)",
        fontWeight: 600,
        textTransform: "capitalize",
      }}>
        Notification
      </h1>

      {/* ✅ FORM */}
      <div style={{
        display: "flex",
        flexDirection: "column",
        gap: "20px",
        maxWidth: "900px",
      }}>

        {/* Title + Users — side by side desktop, stacked mobile */}
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
          gap: "20px",
        }}>
          {/* Notification Title */}
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            <label style={{ fontSize: "14px", textTransform: "capitalize", color: "white" }}>
              Notification Title
            </label>
            <input
              type="text"
              placeholder="Notification Title"
              value={notificationTitle}
              onChange={handleNotificationTitle}
              style={{
                padding: "12px 16px",
                borderRadius: "8px",
                border: "none",
                outline: "none",
                fontSize: "16px",
                width: "100%",
                boxSizing: "border-box",
                backgroundColor: "white",
                color: "#1f2937",
                fontFamily: "inherit",
              }}
            />
          </div>

          {/* Select Users */}
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            <label style={{ fontSize: "14px", textTransform: "capitalize", color: "white" }}>
              Select Users
            </label>
            <div style={{ color: "#1f2937" }}>
              <MultiSelect
                options={users}
                value={selectFromMS}
                onChange={setselectFromMS}
                labelledBy="Search and select users..."
                valueRenderer={(selected) =>
                  selected.length
                    ? selected.map(({ label }) => label).join(", ")
                    : "No Users Selected"
                }
                ItemRenderer={({ checked, option, onClick, disabled }) => (
                  <div
                    onClick={onClick}
                    style={{ display: "flex", alignItems: "center", gap: "10px", padding: "6px 4px", cursor: "pointer", opacity: disabled ? 0.4 : 1 }}
                  >
                    <input type="checkbox" checked={checked} onChange={() => {}} style={{ flexShrink: 0 }} />
                    <div>
                      <div style={{ fontWeight: 500, fontSize: "14px", color: "#1f2937" }}>{option.label}</div>
                      {option.email && (
                        <div style={{ fontSize: "12px", color: "#6b7280" }}>{option.email}</div>
                      )}
                    </div>
                  </div>
                )}
              />
            </div>
          </div>
        </div>

        {/* Notification Text */}
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          <label style={{ fontSize: "14px", textTransform: "capitalize", color: "white" }}>
            Notification Text
          </label>
          <textarea
            placeholder="Write something..."
            value={notificationText}
            onChange={handleNotificationTextChange}
            rows={6}
            style={{
              padding: "14px 16px",
              borderRadius: "8px",
              border: "none",
              outline: "none",
              fontSize: "16px",
              width: "100%",
              boxSizing: "border-box",
              resize: "vertical",
              fontFamily: "inherit",
              backgroundColor: "white",
              color: "#1f2937",
            }}
          />
        </div>

        {/* Submit Button */}
        <button
          onClick={() => setOpen(true)}
          style={{
            padding: "12px 40px",
            backgroundColor: "white",
            color: "#1f2937",
            border: "none",
            borderRadius: "8px",
            fontSize: "16px",
            fontWeight: 600,
            cursor: "pointer",
            textTransform: "capitalize",
            width: "100%",
            maxWidth: "200px",
          }}
        >
          Submit
        </button>
      </div>

      {/* ✅ NOTIFICATIONS TABLE */}
      <div style={{ marginTop: "40px", overflowX: "auto" }}>
        <NotificationsTable notifications={notificationsList} />
      </div>
    </div>
  );
};

export default Notifications;